// takes as input a line.serials value, the quantity of the serialized
// item in question, and a boolean, indicating whether auto serial numbering
// is on for this transaction; returns a serial number array, or null, ready
// for PUTing or POSTing via the API
export function normalizeSerials(
  serials,
  lineQuantity,
  isItemSerialTracked,
  autoSerialLotNumber
) {
  if (!isItemSerialTracked) {
    return null;
  }

  const quantity = lineQuantity.toNumber();

  if (autoSerialLotNumber) {
    return !serials?.length
      ? null // return null if the entire quantity is to be auto numbered
      : truncateSerials(serials, quantity);
  }

  const arrayedSerials = serials || [];
  return truncateSerials(arrayedSerials, quantity);
}

function truncateSerials(serials, quantity) {
  return serials.slice(0, quantity);
}
